import React, { useEffect, useState } from "react";
import ReactConfetti from "react-confetti";

import { useSignups } from "Signups/state.js";

export default function Confetti() {
  const [state] = useSignups();

  const isConfettiEffectEnabled =
    state.currentSignupList?.options?.showConfetti;
  const { showConfetti } = state;
  const [renderConfetti, setRenderConfetti] = useState(false);

  useEffect(() => {
    if (showConfetti !== 0) setRenderConfetti(true);
  }, [showConfetti]);

  const signupHasCostAssociated = state.currentSignupList?.signupItems?.some(
    (item) => item.hasSignupCost && item?.amount > 0
  );

  if (!isConfettiEffectEnabled || signupHasCostAssociated) return null;

  const onComplete = () => {
    setRenderConfetti(false);
  };

  return (
    <div className="confetti_holder">
      {renderConfetti && (
        <ReactConfetti
          width={window.innerWidth}
          height={document.body.scrollHeight}
          recycle={false}
          numberOfPieces={400}
          tweenDuration={15000}
          onConfettiComplete={onComplete}
        />
      )}
    </div>
  );
}
